module.exports = __webpack_public_path__ + "static/img/high-speed-connector_256.178a6c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/high-speed-connector_256.png
// module id = fzh1
// module chunks = 0